/**
 * Render toolbar
 *
 * @author: Kete Martins
 * Date: 03/12/13
 * Time: 10:57
 */



Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};
Greenmile.Toolbar.Map.SearchAddressOnMap = Greenmile.Toolbar.Map.SearchAddressOnMap || {};

Greenmile.Toolbar.Map.SearchAddressOnMap = function (selector, map, options) {

    if (!selector || !map) {

        return false;

    }

    var sessionSourceData;
    const DOWN_ARROW = 40;
    const ENTER = 13;
    const ESC = 27;
    const TAB = 9;
    const handleToolbarSearchContainer = new Greenmile.Toolbar.Map.Util.handleToolbarSearchContainer(selector);

    if (options && options.sourceSessionData) {
        sessionSourceData = options.sourceSessionData;
    }

    var addMarkerAfterSelectItem = () => {

        const opt = $(selector + " .streetSearchResult select option:selected");
        const lat = opt.attr("lat");
        const lng = opt.attr("lng");
        const address = opt.attr("address");
        const kind = opt.attr("kind");

        const layers = map._layers;
        for (let i in layers) {
            if (layers[i].kind === kind) {
                map.removeLayer(layers[i]);
                break;
            }
        }

        Greenmile.Toolbar.Map.Util.addMarkerToMap(lat, lng, address, null, kind, map);

        if (sessionSourceData) {
            sessionSourceData.addresSelected = opt;
        }

    };

    var clearAfterSelected = () => {
        $(selector + " .streetSearchResult").hide();
        $(selector + " .streetSearchResult").html();
        $(selector + " input[name='searchStreet']").val("");
    };


    this.addListeners = () => {

        const doSearching = (e) => {
            this.canHide = false;

            if (e.keyCode === DOWN_ARROW) {

                $(selector + " .streetSearchResult select").trigger("focus");
                $(selector + " .streetSearchResult select").val($(selector + " .streetSearchResult select option:first").val());
            } else {
                this.requestGeocode();
            }
        };

        let timeoutId;
        $(selector + " input[name='searchStreet']").on("keyup", (e) => {
            const inputText = $(selector + " input[name='searchStreet']").val();

            if(inputText.length === 0) {
                timeoutId && clearTimeout(timeoutId);
                clearAfterSelected();
            }
        });

        $(selector + " input[name='searchStreet']").on("keydown", (e) => {
            timeoutId && clearTimeout(timeoutId);
            timeoutId = setTimeout(() => doSearching(e), 750);
        });


        $(selector + " input[name='searchStreet']").on("blur", () => {

            if (this.canHide) {
                clearAfterSelected();
            }

        });

        $(selector + " .streetSearchResult").on("mouseover", () => (this.canHide = false) );

        $(selector + " .streetSearchResult select").on('keydown', (e) => {

            if (e.keyCode === ENTER) {
                addMarkerAfterSelectItem();
            }

        });

    };

    this.requestGeocode = () => {
        handleToolbarSearchContainer.mountSection();

        let gGeocode = new Greenmile.Geocoding(map);

        gGeocode.geocode(selector + " input[name='searchStreet']", (data) =>  {
            this.renderGeocodeResult(data);
        }, (e) => {
            handleToolbarSearchContainer.showNotDataText();
            console.log(e);
        });
    };

    this.addSelectListeners = () => {

        $(selector + " .streetSearchResult select").on('keydown', (e) => {

            if (e.keyCode === ENTER) {

                addMarkerAfterSelectItem();
                clearAfterSelected();

            } else {

                if (e.keyCode === TAB) {

                    clearAfterSelected();

                }
            }
        });

        $(selector + " .streetSearchResult select option").on("click", () => {

            addMarkerAfterSelectItem();
            clearAfterSelected();

            this.canHide = true;

        });

        $("#mapContainer").on("click", () => {
            this.canHide = true;
            $(selector + " .streetSearchResult").hide();
        });


    };

    this.renderGeocodeResult = (result) => {

        if(result.length === 0) {
            handleToolbarSearchContainer.showNotDataText();

            return;
        }

        const optGroup = document.createElement("optgroup");
        optGroup.setAttribute("id", "address");
        optGroup.setAttribute("class", "mapInfo");
        optGroup.setAttribute("label", Monet.I18n.getResourcesByKey('Option.goup.address'));

        const contentDataSelector = $(selector + " .streetSearchResult select");
        contentDataSelector.html(optGroup);

        const mapInfoHTMLContainer = document.querySelector(selector + " .mapInfo");
        result.forEach((item) => {
            const option = document.createElement("option");
            option.textContent = item.formatted_address;
            option.setAttribute("lat", item.geometry.location.lat());
            option.setAttribute("lng", item.geometry.location.lng());
            option.setAttribute("address", item.formatted_address);
            option.setAttribute("kind", "marker_address");
            mapInfoHTMLContainer.appendChild(option);
        });

        handleToolbarSearchContainer.showContent();
        this.addSelectListeners();

    };

    this.finish = () => {

        var theEnd = (e) => {

            if (e.keyCode === ESC) {

                for (var i in map._layers) {

                    if (map._layers[i].kind === "marker") {
                        map.removeLayer(map._layers[i]);
                    }
                }

                clearAfterSelected();

            }

        };


        $(selector).off("keydown", theEnd);
        $(selector).on("keydown", theEnd);

    };

    var init = () => ( this.finish() );

    init(this);

};
